<!--
 * @Description:  生成订单弹层,4个步骤
                  tableRender中的search组件为自定义，未与compnents中的同步。
 * @Date: 2022-01-20 11:09:12
-->
<template>
  <el-dialog
    top="5vh"
    @close="close"
    :visible="true"
    :destroy-on-close="true"
    :width="dialogWidth"
    :close-on-click-modal="false"
  >
    <template slot="title">
      <div :style="{ fontSize: '24px' }">{{ title }}</div>
    </template>
    <!-- 1 生成订单  ---------------------------------------------------------------------------------------------------------------------->
    <table-render
      ref="tableRef1"
      v-if="stepNo === 0"
      height="48vh"
      rowKey="id"
      key="1"
      @beforeSearch="beforeSearch"
      :config="stepMap[0].tableConfig"
      :propData="{ query: {} }"
      @selection-change="e => (selection = e)"
      @select="
        (selection, row) => {
          selectRow(row, 'tableRef1');
        }
      "
      @select-all="
        (selection, current) => {
          selectAllRow(selection, current, 'tableRef1');
        }
      "
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
    >
      <!-- 自定义 search -->
      <template #search="{...ops}">
        <search @search="beforeSearch" v-bind="ops"></search>
      </template>
      <!-- 提示信息 start -->
      <template slot="top-alert">
        <el-row type="flex" justify="flex-start">
          <span class="error alert">
            {{ formulaText }}
          </span>
        </el-row>
      </template>
      <!-- 提示信息 ended -->

      <!-- 提示信息 start -->
      <template slot="bottom-alert">
        <el-row type="flex" justify="flex-start">
          <span class="error alert">
            由于每个自然月“供应商服务费率”有可能会有调整，故所有未生成订单内的“供应商服务费率”以及“结算总价”仅当月有效。
          </span>
        </el-row>
      </template>
      <!-- 提示信息 ended -->

      <!-- 批量操作 start-->
      <template slot="batchAction">
        <el-row type="flex" align="middle">
          <!--              <div class="batch-actions__btn" @click="selectAllByRowKey(scope)">全选</div>-->
          <!--              <div class="batch-actions__btn" @click="scope.tableRef.clearSelection()">清空</div>-->
          <div class="batch-actions__info">
            <span class="batch-actions__btn" @click="clearCart('tableRef1')">
              清空
            </span>
            <i
              class="el-icon-shopping-cart-2 batch-actions__info__icon"
              style="font-size: 20px; margin: 0 8px;cursor:pointer"
            ></i>
            <p class="batch-actions__count">
              已选笔数：
              <span class="batch-actions__info__mark">
                {{ (cartInfo && cartInfo.peopleCount) || 0 }}
              </span>
              项目支付总计金额:
              <span class="batch-actions__info__mark">
                {{ (cartInfo && cartInfo.sumAmount) || 0 }}元
              </span>
            </p>
          </div>
          <projectData
            :totalProjectByIds="totalProjectByIds"
            :tableData="countProjectList"
          ></projectData>
        </el-row>
      </template>
      <!-- 批量操作 ended-->
    </table-render>

    <!-- 2 确认笔数  ------------------------------------------------------------------------------------------------------------------------>
    <table-render
      ref="tableRef2"
      v-else-if="stepNo === 1"
      :config="stepMap[1].tableConfig"
      height="50vh"
      rowKey="id"
      key="2"
      :propData="{ query: { ...cartComputedInfoQuery } }"
      @select="
        (selection, row) => {
          selectRow(row, 'tableRef2');
        }
      "
      @select-all="
        (selection, current) => {
          selectAllRow(selection, current, 'tableRef2');
        }
      "
      @selection-change="e => (selection = e)"
      @respondFinished="res => refreshtotalCount(res)"
    >
      <!-- 提示信息 start -->
      <template slot="top-alert">
        <el-row type="flex" justify="flex-start">
          <span class="error alert">
            {{ formulaText }}
          </span>
        </el-row>
      </template>
      <!-- 提示信息 ended -->

      <!-- 批量操作 start-->
      <template slot="batchAction">
        <el-row type="flex" align="middle">
          <div class="batch-actions__info">
            <!--               <el-button size="medium" type="text" @click="scope.tableRef.selectAllByRowKey()"> 全选 </el-button>-->
            <el-button
              size="medium"
              type="text"
              @click="clearCart('tableRef2')"
            >
              清空
            </el-button>
            <i
              class="el-icon-shopping-cart-2 batch-actions__info__icon"
              style="font-size: 20px; margin: 0 8px;cursor:pointer"
            ></i>
            <span class="batch-actions__count">
              已选笔数：
              <span class="batch-actions__info__mark">
                {{ (cartInfo && cartInfo.peopleCount) || 0 }}
              </span>
              项目支付总计金额:
              <span class="batch-actions__info__mark">
                {{ (cartInfo && cartInfo.sumAmount) || 0 }}元
              </span>
            </span>
          </div>
          <projectData
            :totalProjectByIds="totalProjectByIds"
            :tableData="countProjectList"
          ></projectData>
          <div style="margin-left:15px;">
            <span>支付通道：{{ payBankText }}</span>
            <span style="margin-left:15px;">
              服务商付款方式：{{ payTypeText }}
            </span>
          </div>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center"></el-row>
      </template>
      <!-- 批量操作 ended-->
    </table-render>

    <!-- 3 订单信息确认  ------------------------------------------------------------------------------------------------------------------------>
    <table-render
      v-else-if="stepNo === 2"
      :config="stepMap[2].tableConfig"
      height="60vh"
      :propData="{ query: { ...cartComputedInfoQuery } }"
    >
      <!-- 批量操作 start-->
      <template slot="batchAction">
        <el-row type="flex" align="middle">
          <div class="batch-actions__info">
            <p class="batch-actions__count">
              <span>
                项目数：{{ (cartInfo && cartInfo.projectCount) || 0 }}
              </span>
              <span>
                支付任务数：{{ (cartInfo && cartInfo.dataCount) || 0 }}单
              </span>
              <span>
                支付金额合计：{{ (cartInfo && cartInfo.sumAmount) || 0 }}元
              </span>
            </p>
          </div>
          <projectData
            :totalProjectByIds="totalProjectByIds"
            :tableData="countProjectList"
          ></projectData>
          <div style="margin-left:15px;">
            <span>支付通道：{{ payBankText }}</span>
            <span style="margin-left:15px;">
              服务商付款方式：{{ payTypeText }}
            </span>
          </div>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center"></el-row>
      </template>
    </table-render>

    <el-form v-else-if="stepNo === 3" label-width="180px" :model="orderResult">
      <el-form-item label="批次编号：">
        <span>{{ orderResult.batchOrderNo }}</span>
      </el-form-item>
      <el-form-item label="订单编号：">
        <div style="height: 110px;overflow-y: scroll">
          <div v-for="item in orderResult.orderNoList" :key="item.id">
            {{ item }}
          </div>
        </div>
      </el-form-item>
      <el-form-item label="订单生成时间：">
        <span>
          {{ orderResult.createDt }}
        </span>
      </el-form-item>
      <el-form-item label="项目数：">
        <span>{{ orderResult.projectNum }}个</span>
      </el-form-item>
      <el-form-item label="支付任务数：">
        <span>{{ orderResult.payTaskNum }}单</span>
      </el-form-item>
      <el-form-item label="支付金额合计：" style="font-weight:bold">
        <span class="fw500" style="font-weight:bold">
          {{ orderResult.payTotaleNum | moneyFixed }}
        </span>
      </el-form-item>
    </el-form>

    <el-row type="flex" justify="center">
      <!-- <el-button :disabled="stepNo==0" :style="{opacity:stepNo==0?0:1}"  type="primary" size="default" @click="preStep">上一步</el-button> -->
      <el-button
        type="primary"
        size="default"
        v-if="[1, 2].includes(stepNo)"
        @click="preStep"
      >
        上一步
      </el-button>
      <el-button
        :loading="btnLoading"
        type="primary"
        size="default"
        :disabled="!canSubmit"
        @click="nextStep"
      >
        {{ nextName }}
      </el-button>
      <el-button type="primary" size="default" @click="close" plain>
        关闭
      </el-button>
    </el-row>
    <!-- asp个人最大可结算量生成订单 提示窗 -->
    <el-dialog
      :visible.sync="innerVisible"
      width="500px"
      top="30vh"
      title="温馨提示"
      append-to-body
      :before-close="closeDialog"
    >
      <div class="wrap_inner">
        <p>{{ toastMessage }}</p>
        <div class="foot_wrap">
          <el-button
            style="background:rgba(198,203,212,1);color:#fff;margin-right: 40px;"
            @click="back(true)"
          >
            返回
          </el-button>
          <el-button type="primary" size="default" @click="confirmSavePage()">
            确认
          </el-button>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import projectData from '../../components/projectData';
import tableRender from '@/components/tableRender';
import search from '../../components/search';
import { step_0, step_1, step_2 } from './config';
import { orderManagement } from '@/api/ajax.js';
import { easyCopy, deepClone } from '@/tools';
import { useQuotaDialog, imitateAjax } from '@/page/settlementCenter/utils';
import {
  getCacheKey,
  countSelectBill,
  setAllCacheCheck,
  setCacheCheckForRows,
  getElTableComponent
} from './service.js';
import { editOperatorCommonFields } from '@/page/settlementCenter/utils/index.js';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';
import { payTypeFormatter, payBankFormatter } from '@/common/fields/bank';

export default {
  name: 'ProjectSettledOrderCreate', //项目结算订单生成
  props: ['value', 'userEnterpriseType'],
  components: { tableRender, search, projectData },
  data() {
    return {
      innerVisible: false,
      toastMessage: '',
      getUnqualifiedRowConfig,
      totalProjectByIds: [],
      stepNo: 0, // 0选择订单 1确认订单 2确定生成 3前往支付
      stepMap: {
        0: {
          title: '生成自然人订单',
          confirmName: '下一步',
          tableConfig: deepClone(step_0)
        },
        1: {
          title: '确认笔数',
          confirmName: '下一步',
          tableConfig: deepClone(step_1)
        },
        2: {
          title: '订单信息确认',
          confirmName: '确认生成订单',
          tableConfig: deepClone(step_2)
        },
        3: {
          title: '订单已成功生成',
          confirmName: '前往支付'
        }
      },
      selection: [],
      sumAmount: 0,
      cartInfo: {
        peopleCount: 0,
        sumAmount: 0, // 支付钱
        userCount: 0, // 支付人
        taskCount: 0 //  支付任务单数
      },
      dialogWidth: '95%',
      orderResult: {},
      countProjectList: [], // 项目统计
      createdSelected: [] // 备份生成订单选择
    };
  },
  computed: {
    payTypeText() {
      return payTypeFormatter(this.selection.length ? this.selection[0] : {});
    },
    payBankText() {
      return payBankFormatter(this.selection.length ? this.selection[0] : {});
    },
    formulaText() {
      return this.userEnterpriseType === 3
        ? '【项目支付金额】计算公式为：结算总价 = 终端结算单价 * 任务量。项目支付金额为所有结算总价总和'
        : '【项目支付金额】计算公式为：结算总价=终端结算金额*(1+服务费率）。服务费率是完税成本。项目支付金额为所有结算总价总和';
    },
    cacheKey() {
      return getCacheKey();
    },
    // 任务量是否更改，该值为时间戳
    cacheRowChangeFlag() {
      return this.$store.getters['projectSettled/cacheRowChangeFlag'];
    },
    // 第三步 需要限制子账号
    canSubmit() {
      return (
        this.selection.length &&
        (this.stepNo === 3 ? this.$store.getters.isMaster : true)
      );
    },
    btnLoading() {
      return this.$store.state.loading.btLoading;
    },
    title: function() {
      return this.stepMap[this.stepNo].title;
    },
    visible: {
      set: function(v) {
        this.$emit('input', v);
      },
      get: function() {
        return this.value || false;
      }
    },

    // 计算总金额 集合
    selectionsOfSuperKey() {
      return this.selection.map(i => i.id);
    },

    // 购物车 请求信息的 接口参数
    cartComputedInfoQuery() {
      return this.selection.map(i => i.id);
    },
    nextName() {
      return this.stepMap[this.stepNo].confirmName;
    }
  },
  watch: {
    // 结算量更改后同步表格下方数据
    async cacheRowChangeFlag() {
      this.$nextTick(async () => {
        const resp = await countSelectBill();
        this.countProjectList = resp.countProjectList;
        this.cartInfo = { ...this.cartInfo, ...resp };
      });
    },
    // 购物车 订单数量 发生变化 请求接口获取价格等信息
    selection: {
      async handler(v) {
        if (!v.length) {
          this.cartInfo = this.$options.data().cartInfo;
          this.$store.commit('projectSettled/SET_PAYTYPE', '');
          return;
        }
        this.$store.commit('projectSettled/SET_PAYTYPE', v[0].payType);
        this.totalProjectByIds = this.selection.map(i => i.id);
      },
      deep: true,
      immediate: true
    },
    // 监听当前弹层，同步购物车与选项
    async stepNo(v) {
      // 生成订单
      if (v === 0) {
        // 优先使用返回中备份数据，分开勾选使用
        this.syncSelection('tableRef1');
      }
      // 进入确认笔数并同步对应数据
      if (v === 1) {
        this.syncSelection('tableRef2');
      }
    }
  },
  methods: {
    beforeSearch() {
      this.clearCart('tableRef1');
    },
    isNotUnqualified(row) {
      return !(row.zbBlackStatus === 2);
    },
    // 当前行勾选后，缓存数据与同步下方统计数据
    async selectRow(row, ref) {
      console.log(row, 'rowwwww');

      try {
        await setCacheCheckForRows(row);
      } catch (e) {
        getElTableComponent(this.$refs[ref].$children).toggleRowSelection(
          row,
          false
        );
      }
    },
    // 当前页全部勾选，缓存数据与同步下方统计数据
    async selectAllRow(selection, current, ref) {
      try {
        await setCacheCheckForRows(current);
      } catch (e) {
        const noChecked = []; // 未选中集合，新变量，作用于防止toggleRowSelection后删除selection中元素
        selection.forEach(item => {
          if (!item.isChecked) {
            noChecked.push(item);
          }
        });
        noChecked.forEach(item => {
          if (!item.isChecked) {
            getElTableComponent(this.$refs[ref].$children).toggleRowSelection(
              item,
              false
            );
          }
        });
      }
    },
    // 同步selection数据
    async syncSelection(ref, selection) {
      // 备份已选
      let copySelection = easyCopy(selection || this.selection);
      this.$nextTick(async () => {
        // 清空当前table中的selection，selectAllByRowKey方法不提供再次重新赋值。
        this.$refs[ref].clearTableSelection();
        let _selection = await this.$refs[ref].selectAllByRowKey({
          superKeys: copySelection // 使用备份
        });
        // 同步引用
        this.selection = _selection;
        console.log(this.selection, 'this.selection');
      });
    },

    closeDialog() {
      this.back(true);
    },
    // 刷新统计数据
    refreshtotalCount() {
      this.$nextTick(async () => {
        const resp = await countSelectBill();
        this.countProjectList = resp.countProjectList;
        this.cartInfo = { ...this.cartInfo, ...resp };
      });
    },
    async preStep() {
      // 为了兼容后端张志宏无法处理缓存问题，前端又额外增加接口 并额外提了个bug
      // 只在自然人订单 点击第一个上一步 通知后端
      if (this.userEnterpriseType === 1 && this.stepNo === 1) {
        (await this.back()) && this.refreshtotalCount();
      }
      this.stepNo = Math.max(this.stepNo - 1, 0);
    },

    // 返回 并初始化数据
    async back(close = true) {
      await orderManagement.presStep({
        cacheKey: this.cacheKey
      });
      if (close) {
        this.innerVisible = false;
      }
      return true;
    },
    async confirmSavePage() {
      let bol = true;
      // 校验极端情况 如果弹窗里无数据 就不用唤起第二层弹窗
      try {
        const {
          pdata: { list }
        } = await orderManagement.getConfirmOrderPeopleList({
          pageNo: 1,
          pageSize: 9999,
          cacheKey: this.cacheKey
        });
        const selectIds = list.map(item => item.id).join(',');
        const allIds = this.selection.reduce((pre, cur) => {
          pre[cur.id] = cur;
          return pre;
        }, {});
        Object.keys(allIds).forEach(async id => {
          if (!selectIds.includes(id + '')) {
            getElTableComponent(
              this.$refs['tableRef1'].$children
            ).toggleRowSelection(allIds[id], false);
            // 不符合的把数据ischecked 0
            const batchJson = JSON.stringify([
              {
                isChecked: 0,
                customizeNum: allIds[id].finishSum,
                id: id
              }
            ]);
            try {
              await orderManagement.isCheck({
                batchJson,
                cacheKey: getCacheKey()
              });
            } catch (err) {
              console.log(err, 'err');
            }
          }
        });
      } catch (err) {
        console.log(err, 'err~~~~~~~~~~~~~~~~~~~~');
        if (String(err.status) === '0' && err.code === '0') {
          bol = false;
        }
      }

      if (!bol) {
        return;
      }

      this.stepNo += 1;
      this.innerVisible = false;
      this.refreshtotalCount();
    },

    async nextStep() {
      // 仅生成自然人订单做限额验证
      if (this.userEnterpriseType === 1 && this.stepNo === 0) {
        // 效验
        let { data } = await orderManagement.checkQuota({
          cacheKey: this.cacheKey
        });
        if (String(data.code) === '102') {
          this.toastMessage = data.message || '';
          this.innerVisible = true;
          return;
        }
      }
      // 前往支付
      if (this.stepNo === 3) {
        this.$router.push({
          name: 'orderMgmt|list',
          query: {
            orderNo: this.orderResult.orderNo
          }
        });
      }
      if (this.stepNo >= 3) {
        this.close();
        this.visible = false;
        return false;
      }
      // 确认生成订单 code为-1则去提示列表
      if (this.stepNo === 2) {
        try {
          /*
            订单数组：payCsoCustomOrderList []
            批次对象：payCsoBatchOrder {}
          */
          let { pdata } = await orderManagement.generateOrder({
            cacheKey: this.cacheKey
          });
          // 刷新结算列表
          this.$emit('finished');
          // 设置订单成功的内容
          this.orderResult = { ...pdata, ...this.cartInfo };
          this.dialogWidth = '40%';
        } catch ({ data, code }) {
          if (+code === -1) {
            useQuotaDialog.call(
              this,
              { query: { isOrder: 0 } }, // isOrder   0生成订单 1支付订单
              imitateAjax(data)
            );
          }
          return;
        }
      }
      this.stepNo += 1;
    },

    close() {
      this.$store.commit('projectSettled/SET_PAYTYPE', '');
      this.$emit('input', false);
      this.$emit('close');
    },
    clearCart(ref) {
      this.$refs[ref].clearTableSelection();
      this.$refs[ref].tableData.forEach(item => {
        item.isChecked = 0;
      });
      this.selection = [];
      this.totalProjectByIds = [];
      // 取消缓存
      setAllCacheCheck({ isAll: 0 });
    }
  },
  created() {
    for (const key in this.stepMap) {
      // 三步生成设置缓存key
      if (key != 3) {
        const currentChildMenu = this.stepMap[key].tableConfig[0].childMenu[0];
        const currentFields = currentChildMenu.fields;
        const currentSearch = currentChildMenu.search;
        currentChildMenu.defaultQuery = {
          cacheKey: this.cacheKey
        };
        // 新个体字段替换与删除
        if (this.userEnterpriseType === 3) {
          currentChildMenu.defaultQuery.userEnterpriseType = 3;
          if (+key === 0) {
            this.stepMap[key].title = '生成个体订单';
          }
          // 修改字段，适配个人、个体
          editOperatorCommonFields({
            currentFields,
            currentSearch,
            userEnterpriseType: this.userEnterpriseType
          });
        }
      }
    }
  }
};
</script>
<style lang="scss">
.wrap_inner {
  > p {
    max-height: 200px;
    overflow-y: auto;
  }

  .foot_wrap {
    width: 100%;
    margin: 30px 0px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.error {
  color: #f56c6c;
}

.alert {
  text-align: left;
  line-height: 30px;
  padding-right: 30px;
}
</style>
